<!-- =========================================================================================
  File Name: BoardAdd.vue
  Description: Board Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-board-add">

    <vx-card title="게시글 추가" class="mb-base" >
      <board-add-form class="mt-4" />
    </vx-card>

  </div>
</template>

<script>
import BoardAddForm  from './BoardAddForm'

export default {
  components: {
    BoardAddForm
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
  
}

</script>
